import * as React from "react";

import classNames from "classnames";

import { BE_06, BLOG_ENTRY_DEFAULTS } from "@stadium/shared/src/helpers/plasmic/static-slices";
import { OTHER_LINK_TYPE } from "@stadium/shared/src/constants/stores/routes";

import Multimedia from "@stadium/shared/src/components/shared/multimedia";
import { LinkWithLang } from "components/plasmic/shared/link-with-lang/client";

import styles from "./main.module.scss";

interface BE06Card {
  image: string;
  imageAlt: string;
  title: string;
  description: string;
  link: string;
}

export interface BE06Props {
  className?: string;
  cards?: BE06Card[];
}

const defaults = BLOG_ENTRY_DEFAULTS[BE_06];

const BE06: React.FC<Readonly<BE06Props>> = ({ className, cards = defaults.cards }) => {
  return (
    <section className={classNames(styles.sectionWrapper, className)}>
      <div className={styles.divWrapper}>
        <div className={styles.cardsGrid}>
          {cards.map((card) => (
            <LinkWithLang
              key={card.title || card.link}
              type={OTHER_LINK_TYPE}
              data={{ url: card.link }}
              className={styles.card}
            >
              <div className={styles.cardContent}>
                {card.image && (
                  <div className={styles.imageWrapper}>
                    <Multimedia
                      type="image"
                      src={card.image}
                      alt={card.imageAlt}
                      className={styles.cardImage}
                    />
                  </div>
                )}
                <div className={styles.textContent}>
                  <h3 className={styles.cardTitle}>{card.title}</h3>
                  <p className={styles.cardDescription}>{card.description}</p>
                </div>
              </div>
            </LinkWithLang>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BE06;
